import { IChatListDto, IMessageOfferParsedText, IOfferedBuyProductDto, MessageTypeEnum, OfferStatusEnum } from "@/Models/Chat";


export const getDescriptionByItem = (item: IOfferedBuyProductDto | IChatListDto, t: (key: string) => string) => {
  let description = '';
  let last_offer_msg = {} as IMessageOfferParsedText;
  
  if(item.messageType === MessageTypeEnum.OFFER) {
    last_offer_msg = JSON.parse(item.messageText) as IMessageOfferParsedText;
    switch (last_offer_msg.status) {
      case OfferStatusEnum.CANCELED:
        description = t('canceled').toUpperCase();
        break;
      case OfferStatusEnum.ACCEPTED:
        description = t('accepted').toUpperCase();
        break;
      case OfferStatusEnum.REJECTED:
        description = t('rejected').toUpperCase();
        break;
      case OfferStatusEnum.PENDING:
        description = t('pending').toUpperCase();
        break;
      case OfferStatusEnum.SOLD:
        description = t('sold').toUpperCase();
        break;
      case OfferStatusEnum.AVAILABLE:
        description = t('available').toUpperCase();
        break;
      case OfferStatusEnum.NOT_AVAILABLE:
        description = t('notAvailable').toUpperCase();
        break;
      default:
        break;
    }
  } else if(item.messageType === MessageTypeEnum.LOCATION) {
    description = t('location');
  } else {
    description = item.messageText;
  }

  return [description, last_offer_msg] as const;
}
